import { useGet } from '../../../sharedModules/hooks/useQuery';
import { CollectionClientDetail } from '../model';

export function useCollectionClient(id: number | null, enabled = true) {
  return useGet<CollectionClientDetail>({
    url: id ? `/collections/clients/${id}` : '',
    enabled: !!id && enabled,
  });
}
